/* 
Object:         Tabguard
Description:    This ensures that there is only one tab active for the session. If another tab opens the existing tab will be redirected to the login page.
Used in:        Web Application main (global)
*/

export function initialize(): void {

    window.addEventListener("storage", storageHandler, false);

    const time = new Date().getTime().toString();
    window.name = time;
    localStorage.setItem('tabGuard', time);
};

/**
* If the browser tab guard value changed in a different tab redirect to login page
* @param {StorageEvent} e
*/
function storageHandler(e: StorageEvent): void {

    // Do not refresh the current login page and begin a infinite loop against two or more tabs
    if (!e.url.includes("Login")) {
        if (e.key === "tabGuard" && window.name !== e.newValue) {
            window.location.assign(window.origin + "?tabguard=true");
        }
    }
}